// extracted by mini-css-extract-plugin
var _1 = "MyDashboard_MyDashboard__e45C2";
var _2 = "MyDashboard_itemTitle__qbGoU";
var _3 = "MyDashboard_slider__6e4I3";
var _4 = "MyDashboard_sliderArrow__tvpUw";
var _5 = "MyDashboard_sliderContainer__EdgHn";
var _6 = "MyDashboard_sliderDots__kqBPL";
var _7 = "MyDashboard_sliderItem__tbVqJ";
var _8 = "MyDashboard_sliderItemContainer__6LxuE";
export { _1 as "MyDashboard", _2 as "itemTitle", _3 as "slider", _4 as "sliderArrow", _5 as "sliderContainer", _6 as "sliderDots", _7 as "sliderItem", _8 as "sliderItemContainer" }
